import * as selectors from './form.selectors';
import reducer from './form.reducers';

export default reducer;
export { selectors, reducer };
export { FormAction } from './form.actions';
export { FormEffects } from './form.effects';
export { FormState } from './form.models';
export { FormService } from './form.service';
